import { ScrollMode } from './PdfViewer.constants'

export function checkIsPdfViewerPageScrollMode(scrollMode) {
  return scrollMode === ScrollMode.PAGE
}
